import { lazy } from "react";

const PricingTable = lazy(() => import("./PricingTable"));
const SearchResults = lazy(() => import("./SearchResults"));
const UserProfile = lazy(() => import("./UserProfile"));
const BlankPage = lazy(() => import("./BlankPage"));
const FAQ = lazy(() => import("./FAQ"));
const DetailsForm = lazy(() => import("./DetailsForm"));
const EmployeeDetails = lazy(() => import("./EmployeeDetails"));
const PersonalDetails = lazy(() => import("./PersonalDetails"));
const AddressDetails = lazy(() => import("./AddressDetails"));
const BankDetails = lazy(() => import("./BankDetails"));
const MedicalInsuranceNomination = lazy(() => import("./MedicalInsuranceNomination"));
const NomineeDetails = lazy(() => import("./NomineeDetails"));
const ExistingPFDetails = lazy(() => import("./ExistingPFDetails"));
const GratuityNomination = lazy(() => import("./GratuityNomination"));
const Attachments = lazy(() => import("./Attachments"));
const ProfilePage = lazy(() => import("./ProfilePage"));
const EmployeePreview = lazy(() => import("./EmployeePreview"));
const EmployeePreviewWrapper = lazy(() => import("./EmployeePreviewWrapper"));
const EmployeeBasicDetails = lazy(() => import("./EmployeeBasicDetails"));
const FormValidations = lazy(() => import("./FormValidations"));
const Details = lazy(() => import("./Details"));
const Signature = lazy(() => import("./Signature"));
const FormPreviewPage = lazy(() => import("../dynamic-forms/FormPreviewPage"));
const Form1 = lazy(() => import("../dynamic-forms/Form-1"));
const Form16 = lazy(() => import("../dynamic-forms/Form16"));
const FormF = lazy(() => import("../dynamic-forms/FormF"));
const Form2 = lazy(() => import("../dynamic-forms/Form2"));
const AppointmentLetter = lazy(() => import("../dynamic-forms/AppointmentLetter"));
const Form11 = lazy(() => import("../dynamic-forms/Form11"));
const JointDeclarationForm = lazy(() => import("../dynamic-forms/JointDeclarationForm"));
const GratuitySelfDeclaration = lazy(() => import("../dynamic-forms/GratuitySelfDeclaration"));
const LeaveEncashmentSelfDeclaration = lazy(() => import("../dynamic-forms/LeaveEncashmentSelfDeclaration"));
const AadharOtpVerification = lazy(() => import("./AadharOTPVerification"));
const pagesRoutes = [
  {
    path: "/pages/pricing-table",
    element: <PricingTable />,
  },
  {
    path: "/pages/search-results",
    element: <SearchResults />,
  },
  {
    path: "/pages/user-profile",
    element: <UserProfile />,
  },
  {
    path: "/pages/faq",
    element: <FAQ />,
  },
  {
    path: "/pages/blank-page",
    element: <BlankPage />,
  },
  {
    path: "/pages/detailsform",
    element: <DetailsForm />,
  },
  {
    path: "/pages/employeedetails",
    element: <EmployeeDetails/>,
  },
  {
    path: "/pages/personaldetails",
    element: <PersonalDetails />,
  },
  {
    path: "/pages/addressdetails",
    element: <AddressDetails />,
  },
  {
    path: "/pages/bankdetails",
    element: <BankDetails />,
  },
  {
    path: "/pages/medicalinsurance",
    element: <MedicalInsuranceNomination />,
  },
  {
    path: "/pages/nomineedetails",
    element: <NomineeDetails />,
  },
  {
    path: "/pages/existingpfdetails",
    element: <ExistingPFDetails />,
  },
  {
    path: "/pages/gratuitynomination",
    element: <GratuityNomination />
  },
  {
    path: "pages/attachments",
    element: <Attachments />
  },
  {
    path: "pages/profilepage",
    element: <ProfilePage />
  },
  {
    path: "pages/employeepreview",
    element: <EmployeePreview />
  },
  {
    path: "pages/employeebasicdetails",
    element: <EmployeeBasicDetails />
  },
  {
    path: "pages/formvalidations",
    element: <FormValidations />
  },
  {
    path: "pages/details",
    element: <Details />
  },
  {
    path: "/pages/preview-employee",
    element: <EmployeePreviewWrapper  />
  },
  {
    path: "/pages/signature",
    element: <Signature />
  },
  {
    path: "/dynamic-forms/formpreview",
    element: <FormPreviewPage />
  },
  {
    path: "/dynamic-forms/form-1pow",
    element: <Form1 />
  }
  ,
  {
    path: "/dynamic-forms/form-16",
    element: <Form16 />
  },
  {
    path: "/dynamic-forms/form-f",
    element: <FormF />
  },
  {
    path: "/dynamic-forms/form-2pf-nomination-form",
    element: <Form2 />
  },
  {
    path: "/dynamic-forms/appointment-letter",
    element: <AppointmentLetter />
  },
  {
    path: "/dynamic-forms/form-11",
    element: <Form11 />
  },
  {
    path : "/dynamic-forms/joint-declaration-form",
    element : <JointDeclarationForm />
  },
  {
    path : "/dynamic-forms/greystar-gratuity-self-declaration",
    element : <GratuitySelfDeclaration />
  },
  {
    path : "/dynamic-forms/greystar-leave-encashment-self-declaration",
    element : <LeaveEncashmentSelfDeclaration />
  },
  {
    path: "/pages/aadharOtpVerification",
    element: <AadharOtpVerification />
  }

];

export default pagesRoutes;
